
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";

interface EmptyStateRowProps {
  message: string;
  isLoading?: boolean;
  colSpan?: number;
}

export const EmptyStateRow: React.FC<EmptyStateRowProps> = ({ message, isLoading = false, colSpan = 6 }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="h-24 text-center">
        {message}
      </TableCell>
    </TableRow>
  );
};

